module.exports = __webpack_public_path__ + "static/media/Img_info_AD220B.a8a6eee4.jpg";